module.exports = new __parcel__URL__("product-requirements.64ca7b12.svg").toString();